import { render } from "./HeroAddEventModalMain.vue?vue&type=template&id=61660b1e&scoped=true"
import script from "./HeroAddEventModalMain.vue?vue&type=script&lang=js"
export * from "./HeroAddEventModalMain.vue?vue&type=script&lang=js"

import "./HeroAddEventModalMain.vue?vue&type=style&index=0&id=61660b1e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61660b1e"]])

export default __exports__